import { TreeService } from '@aid/members/services/tree.service';
import { MemberChatService } from '@aid/members/services/member-chat.service';

export const services = [TreeService, MemberChatService];

export * from './members.service';
export * from './tree.service';
export * from './member-chat.service';
export * from './member-customers.service';
